
import { useEffect, useState} from 'react';
import { useData } from '../../../contexts/DataContext';
import { useAuth } from '../../../contexts/AuthContext';
import toast from 'react-hot-toast';
import DefaultFormSkeleton from '../../Skeleton/defaultForm';
import { useLocation } from 'react-router-dom';

const CreateInstallment = ({create,setCreate, edit , setEdit, createRes ,showD}) => {

const data = useData();

const initial_form={days:'',percentage:'',duration_type:'days',months:''}
const [itemToEditLoaded,setItemToEditLoaded]=useState(false)
const {pathname} = useLocation()
const duration_types=[{id:'days',label:'Dias'},{id:'months',label:'Meses'}]

const [formData,setFormData]=useState(initial_form)

const [loading,setLoading]=useState(false)

const {user,selectedMicrocredit,userRole,userInfo} = useAuth()

useEffect(()=>{
    if(edit){
       setCreate(false)
    }else{
       setFormData({...initial_form,microcredit_id:selectedMicrocredit || null})
    }
},[edit])

useEffect(()=>{
    if(create){
       setEdit(false)
    }
    setFormData({...initial_form,microcredit_id:selectedMicrocredit || null,duration_type:create=='price'  ? 'months' : create == "simple" ? 'days' : formData.duration_type})
},[create])


useEffect(()=>{
    if(formData.percentage < 0 ){
       setFormData({...formData,percentage:0})
    }else if(formData.percentage > 100){
       setFormData({...formData,percentage:100})
    }
},[formData.percentage])

useEffect(()=>{

   if(formData.duration_type=="months" && formData.months){
      setFormData({...formData,days:30 * parseInt(formData.months)})
   }

},[formData.months])


async function SubmitForm(){

   if(!formData.days || !formData.percentage || (formData.duration_type=="months" && !formData.months)) {
       toast.error('Preencha todos os campos!')
       return 
   }

   let form={
     ...formData,
     months:formData.duration_type=="days" ? null : formData.months
   }

   setLoading(true)
  
   try{

     if(edit){

       await data.makeRequest({method:'post',url:`api/interest-rate/update/`+edit.id,withToken:true,data:{
         ...form,
       }, error: ``},0);
       
       toast.success('Actualizado com sucesso!')
       setLoading(false)

     }else{

       let res=await data.makeRequest({method:'post',url:`api/interest-rate/create`,withToken:true,data:{
         ...form
       }, error: ``},0)

       if(createRes){
         createRes(res)
       }

       toast.success('Criado com sucesso!')
       setLoading(false)

     }

     setEdit(null)
     setCreate(null)
     data.setUpdateTable(Math.random())

   }catch(e){

       let msg="Acorreu um erro, tente novamente"
       console.log(e)
       setLoading(false)

       if(e.response){
         if(e.response.status==409){
             msg="Configuração já existe"
         }   
         if(e.response.status==400){
             msg="Dados inválidos"
         }
         if(e.response.status==500){
             msg="Erro, inesperado. Contacte seu administrador"
         }

       }else if(e.code=='ERR_NETWORK'){
             msg="Verfique sua internet e tente novamente"
       }

       toast.error(msg)
       setLoading(false)

     }
     
}


useEffect(()=>{
  if(!edit){
      setItemToEditLoaded(false)
  }
},[edit])


useEffect(()=>{

    if(!user || !edit?.id){
        return
    }

    (async()=>{
      
      try{
    
      let response=await data.makeRequest({method:'get',url:`api/interest-rate/`+edit.id,withToken:true, error: ``},100);
      setItemToEditLoaded(true)
      console.log({response})
      setFormData({...response,microcredit_id:response.Microcredit.id})
  
      }catch(e){

        console.log({e})

        let msg="Acorreu um erro, tente novamente"

        setLoading(false)

        if(e.response){

          if(e.response.status==409){
            msg="Email já existe"
          } 
          
          if(e.response.status==404){
              msg="Item não encontrado"
              setEdit(null)
          }
          if(e.response.status==500){
              msg="Erro, inesperado. Contacte seu administrador"
          }

        }else if(e.code=='ERR_NETWORK'){
              msg="Verfique sua internet e tente novamente"
        }

    }
    
  })()

},[user,pathname,edit])


   
return (
    <div className={`dialog-container-bg ${showD ? 'show' :''}`}>
     <div className="bg-close" onClick={()=>(edit ? setEdit(null): setCreate(false))}></div>
    <div  className={`create-microcredit ${loading && 'loading'} ${(edit && !itemToEditLoaded) ? 'loading-editing-item':''}`}>
                   {(edit && !itemToEditLoaded) && <DefaultFormSkeleton/>}
                  <div className="top-title">{edit ? 'Editar' :' Adicionar'} taxa de juros</div>  
                  <div className="btn-close" onClick={()=>(edit ? setEdit(null): setCreate(false))}>
                         <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
                  </div>

                  <div className="input-container">

                   <div className="inputs">
                             <span>Tipo de duração<label class="mandatory">*</label></span>
                             <select value={formData.duration_type} onChange={e=>setFormData({...formData,months:'',days:'', duration_type:e.target.value})}>
                                  <option selected value="">Selecione duração</option>
                                  {duration_types.map(i=>(
                                        <option key={i.id} selected={formData.duration_type == i.id} value={i.id}>{i.label}</option>
                                  ))}
                             </select>
                     </div>
                     
                      <div className="inputs">
                           <span>{formData.duration_type=="days" ? 'Dias':'Meses'} </span>
                           <input onWheel={(e) => e.target.blur()} value={formData[formData.duration_type=="days" ? 'days':'months']} max={100} onChange={e=>setFormData({...formData,[formData.duration_type=="days" ? 'days':'months']:e.target.value})} type="number" placeholder={formData.duration_type == "days" ? 'Número de dias':'Número meses'}/>
                      </div>
                      <div className="inputs">
                           <span>Percentagem</span>
                           <input onWheel={(e) => e.target.blur()} value={formData.percentage} max={100} onChange={e=>setFormData({...formData,percentage:e.target.value})} type="number" placeholder="%"/>
                     </div>
                  </div>


              <div className="options">
                  <button className="cancel" onClick={()=>(edit ? setEdit(false) : setCreate(false) )}>Cancelar</button>
                  <div className="div_btn">
                     {(userRole!="operator" || !(!userInfo?.permissions?.contract_settings?.includes('update') && edit)) && <button className="save" onClick={SubmitForm}><span>{edit? 'Actualizar' : 'Adicionar'}</span></button>}
                     <span className="loader"></span>
                  </div>
              </div>

        </div>
         </div>


)
};

export default CreateInstallment;
